import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { patchData } from "../fetchRoutes/patchData";
import { UserContext } from "../context/userContext";

export default function PriceProp(props) {

    const { mainClassName, spanClassname1, spanClassname2, property, isProperty, myProperty, favorite, payment } = props;
    const saveProperty = process.env.REACT_APP_SAVE_PROPERTY;
    const { userDetails, isLoggedIn } = useContext(UserContext);


    const navigate = useNavigate();

    // State to track if the property is saved
    const [isSaved, setIsSaved] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false); // Track hover state

    // Check if property is saved when component mounts
    useEffect(() => {
        if (isLoggedIn && userDetails?.savedProperties?.includes(property?._id)) {
            setIsSaved(true);
        } else {
            setIsSaved(false);
        }
    }, [userDetails, property?._id, isLoggedIn]);

    // Handle favorite
    const handleClick = async (event) => {
        event.preventDefault();

        if (!isLoggedIn) return; // Prevent saving if not logged in

        try {
            const url = `${saveProperty}/${property._id}/save-unsave`;
            await patchData(url);

            // Toggle the saved state
            setIsSaved((prev) => !prev);
        } catch (err) {
            console.error("Something went wrong", err);
        }
    };

    // Handle cardClick
    const handleCardClick = () => {
        navigate(`/properties/property/${property?._id}`);
    };

    return (
        <div className={mainClassName}>
            <span className={spanClassname1} onClick={handleCardClick}>
            £{
                payment ? (
                    property.toLocaleString()
                ) : (
                    (property?.price || property?.bidAmount)?.toLocaleString() + (isProperty ? " starting price" : '')
                )
            }

            </span>
            
            {userDetails?.role === 'buyer' && (!myProperty || favorite) ? (
                <>
                    <span
                        className={`${spanClassname2} ${isSaved ? "addedToFavorite" : ""} save-icon`}
                        onClick={handleClick}
                        onMouseEnter={() => !isLoggedIn && setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        style={{ position: "relative", cursor: isLoggedIn ? "pointer" : "not-allowed" }}
                    >
                    </span>
            
                    {!isLoggedIn && showTooltip && (
                        <span className="toolTip">Log in to save property</span>
                    )}
                </>
            ) : (
                <p></p>
            )}
            
            
        </div>
    );
}
